import { css } from 'lit'

export default css`
    :host {
        max-width: 100%;
        cursor: default;
    }

    .tag {
        display: flex;
        padding: 0 8px;
        height: var(--zaptic-tag-height, 32px);
        align-items: center;
        border-radius: 100vh;
        text-align: center;
        background-color: var(--grey8);
        border: 1px solid var(--grey8);
        color: var(--darkGrey);
        max-width: 100%;
    }

    .tag.has-primary-icon {
        padding-left: 4px;
    }

    .tag.has-image-icon {
        padding-left: 4px;
    }

    .tag.is-removable {
        padding-right: 8px;
    }

    :host(:not(.no-hover)) .tag:not(.is-removable),
    .icon-remove {
        cursor: pointer;
    }

    :host(:where(:not(.no-hover))) .tag:where(:not(.is-disabled):not(.is-removable)):hover {
        background-color: var(--grey6);
        border-color: var(--grey6);
    }

    .icon-remove {
        display: inline-flex;
    }

    .icon-remove > svg {
        width: 16px;
        height: 16px;
    }

    .icon-remove:hover > svg circle {
        fill: var(--grey3);
    }

    .tag > .label {
        height: 14px;
        display: flex;
        flex-direction: row;
        gap: 2px;
        align-items: center;
        font-weight: var(--font-weight-regular);
        font-size: 14px;
        font-style: normal;
        line-height: 1.2;
        max-width: 100%;
    }

    .tag.is-removable > .label {
        gap: 4px;
    }

    .tag.is-showing-selection {
        background-color: var(--backgroundPurple);
        border: 1px solid var(--purple);
        color: var(--purple);
    }

    .tag.is-showing-selection:hover {
        background-color: #e8dffb;
        border: 1px solid var(--purple);
        color: var(--purple);
    }

    .tag.is-active {
        background-color: var(--purple);
        border: 1px solid var(--purple);
        color: white;
    }

    .tag.is-active:hover {
        background-color: var(--purple);
        border: 1px solid var(--purple);
        color: white;
    }

    .tag.is-disabled {
        background-color: var(--grey8);
        border: 1px solid var(--grey8);
        color: var(--grey5);
        cursor: not-allowed;
    }

    .icon {
        height: var(--zaptic-tag-icon-height);
        width: var(--zaptic-tag-icon-width);
    }

    .icon-image {
        width: 24px;
        height: 24px;
        border-radius: 24px;
        background: white;
        flex-shrink: 0;
    }

    .label-text {
        overflow: hidden;
        text-wrap: nowrap;
        text-overflow: ellipsis;
    }

    [data-tooltip] {
        position: relative;
    }

    [data-tooltip]::after {
        position: absolute;
        transform: translateY(1.5rem);
        opacity: 0;
        transition:
            transform 80ms ease-out,
            opacity 80ms ease-out;
        transition-delay: 200ms;
        margin: auto;
        inset: auto 0 calc(100% + 1rem);
        border-radius: 0.4rem;
        background-color: black;
        padding: 0.7rem 1.5rem;
        width: fit-content;
        max-width: 25rem;
        pointer-events: none;
        content: attr(data-tooltip);
        color: white;
        font-size: var(--small);
    }

    [data-tooltip]:hover::after {
        transform: none;
        opacity: 1;
    }
`
